import React from 'react';
import SvgIcon from '../../../../../common/SvgIcon';

const Document = ({ document, disabled, onDelete }) => {
  return (
    <div className="onboarding-uploading_item">
      <a href={document.url} target="_blank" rel="noopener noreferrer" className="onboarding-uploading_link" />
      <div className="onboarding-uploading_name">{document.filename}</div>
      {!disabled && (
        <button
          className="onboarding-uploading_remove"
          onClick={() => onDelete(document.id, document.kind)}
        >
          <SvgIcon icon="icon-remove-button" />
        </button>
      )}
    </div>
  );
};

const Image = ({ image, disabled, kind, deleteImage }) => {
  if (image.state === 'loading') {
    return <div className="onboarding-uploading_item -loading">uploading...</div>;
  } else {
    return (
      <div className="onboarding-uploading_item">
        <img className="onboarding-uploading_image" src={image.url} />
        {disabled ? null : (
          <button
            className="onboarding-uploading_remove"
            onClick={() => deleteImage(image.id, kind)}
          >
            <SvgIcon icon="icon-remove-button" />
          </button>
        )}
      </div>
    );
  }
};

class Photos extends React.Component {
  onChange = (e) => {
    this.props.updateProjectImages(e.target.files, this.props.kind);
  }

  render() {
    const { images, kind, deleteImage, disabled, label, project: { documents }, onDocumentDelete } = this.props;
    const uploadedDocuments = documents.filter(d => d.kind === kind);
    const title = label || ['Upload', <br key="789" />, 'photos'];

    return (
      <div className="onboarding-uploading">
        {disabled ? null : (
          <label className="onboarding-uploading_add">
            <input
              className="onboarding-uploading_add-input"
              type="file"
              accept="image/jpeg,image/jpg,image/png,application/pdf,.dwg"
              onChange={this.onChange}
              multiple
            />
            {title}
          </label>
        )}
        {images.map(image => (
          <Image
            key={image.id}
            image={image}
            deleteImage={deleteImage}
            kind={kind}
            disabled={disabled}
          />
        ))}
        {uploadedDocuments.map(document => (
          <Document key={document.id} document={document} onDelete={onDocumentDelete} />
        ))}
      </div>
    );
  }
}

export default Photos;



// WEBPACK FOOTER //
// ./app/javascript/components/customer/brief/components/UI/Photos.js